import { createActionGroup, props } from '@ngrx/store';
import { Spending, CreateSpendingDto, UpdateSpendingDto, SpendingSummary } from '../../models/spending.model';

export const SpendingActions = createActionGroup({
  source: 'Spending',
  events: {
    'Load Spendings': props<{ from?: string; to?: string }>(),
    'Load Spendings Success': props<{ spendings: Spending[] }>(),
    'Load Spendings Failure': props<{ error: string }>(),
    'Load Spending': props<{ id: number }>(),
    'Load Spending Success': props<{ spending: Spending }>(),
    'Load Spending Failure': props<{ error: string }>(),
    'Create Spending': props<{ dto: CreateSpendingDto }>(),
    'Create Spending Success': props<{ spending: Spending }>(),
    'Create Spending Failure': props<{ error: string }>(),
    'Update Spending': props<{ id: number; dto: UpdateSpendingDto }>(),
    'Update Spending Success': props<{ spending: Spending }>(),
    'Update Spending Failure': props<{ error: string }>(),
    'Delete Spending': props<{ id: number }>(),
    'Delete Spending Success': props<{ id: number }>(),
    'Delete Spending Failure': props<{ error: string }>(),
    'Load Spending Summary': props<{ from?: string; to?: string; groupBy?: string }>(),
    'Load Spending Summary Success': props<{ summary: SpendingSummary[] }>(),
    'Load Spending Summary Failure': props<{ error: string }>(),
  }
});
